import { createContext } from "react";
import { MovieContextType } from "./movieContextTypes";

// Create and export the context
export const MovieContext = createContext<MovieContextType | undefined>(undefined);

// Remove the duplicate MovieProvider export that's causing the conflict
